const merge = require('deepmerge');
const fetch = require('node-fetch');

const defaultOptions = {
	method: 'POST',
	headers: {
		'Content-Type': 'application/json',
		'Accept': 'application/json',
	}
};

const mergeOptions = (options) => merge(defaultOptions, options);
const fetchJson = async (url, options = {}) => {
	const results = await fetch(url, mergeOptions(options))
	return await results.json()
	
}

const query = async (options) => {
	if (!options.query) {
		throw new Error('query property must be supplied');
	}

	const {
		api,
		query,
		variables,
	} = options;

	if (api && api.apiFetch && api.apiFetch.daClientQuery) {
		return await api.apiFetch.daClientQuery(query, variables)
	} else  {
		let url = '/graphql';
		let options = {}
		if (api && api.webFetch) {
			url = api.webFetch.graphQL ? api.webFetch.graphQL : url;
			options = api.webFetch.options ? {...api.webFetch.options} : options; 
		}

		const body = { query: query };
		if (variables) {
			body.variables = variables;
		}

		const fetchOptions = {
			...options,
			body: JSON.stringify(body)
		}
			
		return await fetchJson(url, mergeOptions(fetchOptions));
	}
};

module.exports = { query };